import React from 'react';

interface InputMessageComponentProps {
  id: string;
  error?: string;
  info?: string;
}

export const InputMessageComponent: React.FC<InputMessageComponentProps> = React.memo(
  ({ error, id, info }: InputMessageComponentProps) => (
    <div aria-live="assertive" className="fr-messages-group" id={`${id}-messages`}>
      {!!error && (
        <p className="fr-message fr-message--error" id={`${id}-error-desc`}>
          {error}
        </p>
      )}
      {!!info && (
        <p className="fr-message fr-message--info" id={`${id}-info-desc`}>
          {info}
        </p>
      )}
    </div>
  ),
);

InputMessageComponent.displayName = 'InputMessageComponent';
